module.exports = "/fast-coin/fonts/proxima-nova-bold.otf";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/fonts/proxima-nova-bold.otf
// module id = 2264
// module chunks = 5